import React from "react";
import { NavLink } from "react-router-dom";

const CardViewer = ({ cards, buttonText, addClass, isFa, addClassCircle, addClassGeneral }) => {

    return (
        <>
            <div className={`card-viewer-lower-part ${addClassGeneral}`}>
                <div className="card-viewer-lower-part-card-list for-mobile-view">
                    {cards.map((card, index) => (
                        <div key={index} className={`card-viewer-lower-part-card ${addClass}`}>
                            <div className={`orange-circle ${addClassCircle}`}>
                                {isFa ? card.iconFa : <i className={card.icon}></i>}
                            </div>
                            <div className="card-viewer-lower-part-uppertitledesc">
                                <div className="card-viewer-lower-part-card-title">
                                    {card.title}
                                </div>
                                <div className="card-viewer-lower-part-card-desc">
                                    {card.desc}
                                </div>
                            </div>
                            {card.button && <div className="home-card-viewer-upperbutton">
                                {<NavLink to={card.link}>
                                    <span className="home-card-viewer-button">{card.button}</span>
                                </NavLink>}
                            </div>}
                            {buttonText && <NavLink to={card.link}>
                                <span className="home-card-viewer-button">{buttonText}</span>
                            </NavLink>}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default CardViewer;
